import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Guardian } from '../_models/guardian';
import { AuthHeader } from './../_models/headers';
import { AuthService } from './auth.service';
import { DataUtilService } from './data-util.service';


@Injectable({
  providedIn: 'root'
})

export class GuardianService {
  aHeader = undefined
  public guardianSubject=new BehaviorSubject<Guardian>(new Guardian());
  //public responseObservable=this.guardianSubject.asObservable

  constructor(
    private http: HttpClient,
    private dataUtilService: DataUtilService,private tss:AuthService) {
      this.aHeader = new AuthHeader(tss)
    }

  getByUserId(userId: number) {
      return this.http.get<any>(`${environment.apiUrl}/guardian/angularshow/${userId}`, this.aHeader.bearerJsonHeaders)
      .pipe(map(data => {
        let guardian = this.processGuardian(data)
        this.guardianSubject.next(guardian)
        return guardian
      }))
  }
  getStudentReportsById(userId: number) {
    return this.http.get<any>(`${environment.apiUrl}/student/reportsbyid/${userId}`, this.aHeader.bearerJsonHeaders)
    .pipe(map(data => {
      let myData=[]
      if(this.dataUtilService.isGoodResponse(data)){
        myData= this.dataUtilService.myData(data)
      }
      return myData
    }))
}
  getGuardianReportsById(userId: number) {
    return this.http.get<any>(`${environment.apiUrl}/guardian/reportsbyid/${userId}`, this.aHeader.bearerJsonHeaders)
    .pipe(map(data => {
      let myData=[]
      if(this.dataUtilService.isGoodResponse(data)){
        myData= this.dataUtilService.myData(data)
      }
      return myData
    }))
}
  getById(guardianId: number) {

      return this.http.get<any>(`${environment.apiUrl}/guardian/angularshowbyId/${guardianId}`, this.aHeader.bearerTextHeaders)
      .pipe(map(data => {
        let guardian = this.processGuardian(data)
        this.guardianSubject.next(guardian)
        return guardian
      }))
  }
  getIndex() {

    return this.http.get<any>(`${environment.apiUrl}/guardian/admin_index`, this.aHeader.bearerJsonHeaders)
    .pipe(map(data => {
      let myData=[]
      if(this.dataUtilService.isGoodObjectResponse(data)){
        myData= this.dataUtilService.myObjectData(data)
      }
      return myData
    }))
  }
  processGuardian(dataResponse){
    let guardian = new Guardian()
    if(this.dataUtilService.isGoodResponse(dataResponse)){
      guardian= this.dataUtilService.myData(dataResponse)
    }
    return guardian
  }

  getServerStudentUserIds(){
    let ids = new Array()
    this.guardianSubject.subscribe(
      x=>{
        for(let student of x.students ){
          ids.push(student.server_student_user_id)
        }
      }

    )
    return ids
  }

  getStudentUserIds(){
    let ids = new Array()
    this.guardianSubject.subscribe(
      x=>{
        for(let student of x.students ){
          ids.push(student.server_user_id)
        }
      }

    )
    return ids
  }
  extractUserId(){
    let userId=0
    this.guardianSubject.subscribe(
      x=>{
        userId=x.server_user_id
      }

    )
    return userId
  }
}
